import { createContext, useContext, useEffect, useState, useCallback } from "react";
import api from "@/lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null); // null=loading, false=guest, object=auth

  const refresh = useCallback(async () => {
    try {
      const { data } = await api.get("/auth/me");
      setUser(data);
      return data;
    } catch {
      setUser(false);
      return false;
    }
  }, []);

  useEffect(() => { refresh(); }, [refresh]);

  const handleAuth = (data) => {
    if (data?.token) localStorage.setItem("adnexa_token", data.token);
    setUser(data.user);
    return data.user;
  };

  const login = async (email, password) => handleAuth((await api.post("/auth/login", { email, password })).data);
  const adminLogin = async (email, password) => handleAuth((await api.post("/auth/admin-login", { email, password })).data);
  const register = async (payload) => handleAuth((await api.post("/auth/register", payload)).data);

  const logout = async () => {
    try { await api.post("/auth/logout"); } catch {}
    localStorage.removeItem("adnexa_token");
    setUser(false);
  };

  return (
    <AuthContext.Provider value={{ user, setUser, login, adminLogin, register, logout, refresh }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
